/** Dispatched when a 422 JSON response includes `errors.deletion_constraints` (see `bootstrap.ts`). */
export const DELETION_CONSTRAINT_ERROR_EVENT = 'diagonal:deletion-constraint-error';

export interface DeletionConstraintErrorDetail {
  /** JSON string matching {@link DeletionConstraintFeedbackPayload} from the backend. */
  payloadJson: string;
}
